<div class="modal fade" id="image-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                </button>
            </div>
            <div class="modal-body">
                <img [src]="imageViewerService.imageUrl" target="_blank" />
            </div>
        </div>
    </div>
</div>
